(function () {
    'use strict';

    function insightsIbmStatusLabel(asset) {
        var s = asset ? asset.status : null;
        if (typeof s === 'string') {
            return s;
        }
        if (s && typeof s === 'object' && typeof s.name === 'string') {
            return s.name;
        }
        return asset && typeof asset.asset_status === 'string' ? asset.asset_status : '';
    }

    function insightsIbmStatusDisplay(asset) {
        var label = insightsIbmStatusLabel(asset);
        return typeof label === 'string' ? label.trim() : '';
    }

    function insightsIbmStatusBadgeClass(asset) {
        var label = insightsIbmStatusLabel(asset);
        var normalized =
            typeof label === 'string' ? label.toLowerCase().replace(/\s+/g, '') : '';
        switch (normalized) {
            case 'paused':
                return 'status-paused';
            case 'open':
                return 'status-open';
            case 'completed':
                return 'status-completed';
            case 'active':
                return 'status-active';
            case 'maintenance':
                return 'status-maintenance';
            default:
                return 'status-muted';
        }
    }

    angular
        .module('atheer.session')
        .directive('sessionInsights', sessionInsights);

    function sessionInsights() {
        var directive = {
            scope: {
                sessionModel: '=',
                languages: '=?'
            },
            bindToController: true,
            controller: sessionInsightsController,
            controllerAs: 'vm',
            templateUrl: 'modules/session/session-insights.tmpl.html',
            restrict: 'E'
        };
        return directive;
    };

    /* @ngInject */
    function sessionInsightsController($scope, $rootScope, $mdDialog, $mdSidenav, triTheming, triSettings, $mdToast, $document, $location, $mdPanel, $state, $timeout, $q, $filter, ParseLinks, Principal, Session, Experience, AlertService, paginationConstants, $http, ToastService, SessionsService, Feature, IBM, SessionExternalInvitee, $sce) {
        var vm = this;

        vm.isALMFeatureEnabled = Feature.isActive('feature_asset_management_alm_enabled');
        vm.sessionLinkedAssets = [];

        vm.ibmAssetStatusDisplay = function (asset) {
            return insightsIbmStatusDisplay(asset);
        };

        vm.ibmAssetStatusBadgeClass = function (asset) {
            return insightsIbmStatusBadgeClass(asset);
        };

        vm.openInsightAssetLink = function (asset) {
            if (asset && asset.id != null) {
                IBM.handleIBMRedirect(asset.id);
            }
        };

        vm.loadingData = false;
        vm.transition = transition;
        vm.pageSize = paginationConstants.itemsPerPage;
        vm.sessionActivities = null;
        vm.session_activities = [];
        vm.participantsList = [];
        vm.guestList = [];
        vm.loadingActivities = false;

        vm.feedbackPage = 0;
        vm.ratingAndCommentsActivities = [];
        vm.feedbackActivities = [];
        vm.feedbackPageSize = paginationConstants.itemsPerPage;
        vm.loadingFeedbackActivities = false;
        vm.isLoadingFeedback = false;
        vm.backgroundColor = triTheming.rgba(
            triTheming.getPaletteColor(triSettings.getSkinModel().primary_color, '500').value
        );

        vm.selectedTranscriptLanguage = null;
        vm.transcriptData = [];
        vm.loadingTranscript = false;
        vm.transcriptPDFUrl = "";
        vm.transcriptUrl = "";


        vm.aiSummaryLanguage = null;
        vm.aiSummary = "";
        vm.aiSummaryPDFUrl = "";
        vm.loadingAiSummary = false;
        vm.loadingSessionTranscriptPDF = false;
        vm.selectedAiSummaryType = null;
        vm.aiSummaryTypes = [
            {id: 'long', name: $filter('translate')('atheer.session.insights.longSummary')},
            {id: 'short', name: $filter('translate')('atheer.session.insights.shortSummary')}
        ];

        vm.supportedLanguages = SessionsService.getCaptionsSupportedLanguagesList();
        vm.isTranscriptionFeatureAvailable = SessionsService.isTranscriptionFeatureAvailable();
        vm.isTranslationFeatureAvailable = SessionsService.isTranslationFeatureAvailable();
        vm.isAISummaryFeatureActive = SessionsService.isAISummaryFeatureAvailable();

        vm.currentActiveTab = 'activityLog';
        vm.isAnimationLoaded = false;

        vm.selectedAiSummaryType = vm.aiSummaryTypes[0];
        var showDownConverter = new showdown.Converter();

        vm.getTranscriptMessageTime = function (timestamp, startTime) {
            var sessionStartTime = moment(startTime);
            var messageTime = moment(timestamp);
            var duration = moment.duration(
                Math.abs(messageTime.diff(sessionStartTime))
            );
            var hours = String(Math.floor(duration.asHours())).padStart(2, '0');
            var minutes = String(duration.minutes()).padStart(2, '0');
            var seconds = String(duration.seconds()).padStart(2, '0');

            return hours + ":" + minutes + ':' + seconds;
        };

        vm.changeTranscriptLanguage = function () {
            vm.loadingTranscript = true;
            vm.loadingSessionTranscriptPDF = true;
            loadAiSummary(vm.selectedTranscriptLanguage.id, true);
            loadTranscript(vm.selectedTranscriptLanguage.id);
        };

        function getTranscriptTextHeader(isForTranscript) {
            var transcriptText = "";
            if(isForTranscript) {
                transcriptText += "Transcript\n\n";
            } else {
                transcriptText += (vm.selectedAiSummaryType.id === 'long' ? "Long Summary" : "Short Summary") + "\n\n";
            }
            transcriptText +=  "Title: " + vm.sessionModel.topic + "\n";
            transcriptText += "Date and Time of AiRSession: " + $filter('sessionLocalStartTime')(vm.sessionModel.start_time) + "\n";
            transcriptText += $filter('translate')('atheer.session.insights.participants') + ": " + vm.getParticipantsList() + "\n\n";
            return transcriptText;
        }

        vm.getTranscriptText = function () {
            var transcriptText = "";
            transcriptText += getTranscriptTextHeader(true);
            angular.forEach(vm.transcriptData, function (message) {
                transcriptText +=
                    message.user_name +
                    " [" +
                    message.duration +
                    "] :\n" +
                    message.message +
                    "\n\n";
            });
            return transcriptText;
        };

        function getLanguageCode(language) {
            if(language === 'hostLanguage') {
                return vm.hostLanguage.code.split('::')[0];
            }
            return language;
        }

        function getBaseFileName() {
            var title = $filter('translate')('atheer.session.home.title');
            var sanitizedTitle = title.replace(/\s+/g, '');
            return sanitizedTitle + '_' + vm.sessionModel.session_no;
        }

        function generateTranscriptFileName() {
            var languageCode = getLanguageCode(vm.selectedTranscriptLanguage.id).split('-')[0].toUpperCase();
            return getBaseFileName() + '_Transcript_' + languageCode + '.pdf';
        }

        function generateSummaryFileName() {
            var languageCode = getLanguageCode(vm.aiSummaryLanguage.id).split('-')[0].toUpperCase();
            var summaryType = vm.selectedAiSummaryType.id.charAt(0).toUpperCase() + vm.selectedAiSummaryType.id.slice(1);
            return getBaseFileName() + '_' + summaryType + 'Summary_' + languageCode + '.pdf';
        }

        vm.downloadTranscript = function () {
            if(!vm.transcriptPDFUrl) {
                return;
            }
            downloadFile(vm.transcriptPDFUrl, generateTranscriptFileName());
        };

        vm.changeAiSummaryType = function () {
            vm.isAnimationLoaded = false;
            loadAiSummary();
        };

        vm.changeAiSummaryLanguage = function () {
            vm.isAnimationLoaded = false;
            loadAiSummary();
        };

        vm.getSummaryHTML = function () {
            return showDownConverter.makeHtml(vm.aiSummary);
        };

        vm.getSummaryText = function () {
            return getTranscriptTextHeader() + vm.aiSummary;
        };

        vm.downloadSummary = function () {
            downloadFile(vm.aiSummaryPDFUrl, generateSummaryFileName());
        };

        vm.getLanguageIconUrl = function (language) {
            return "/assets/images/translations/" + language.code + ".svg";
        };

        vm.onCopySuccess = function (e, isForSummary) {
            ToastService.displayToast(
                $filter("triTranslate")(
                    isForSummary
                        ? "atheer.session.insights.summaryCopiedToClipboard"
                        : "atheer.session.insights.transcriptCopiedToClipboard"
                ),
                3000
            );
        };

        var downloadFile = function (url, fileName) {
            $http.get(url, { responseType: 'blob' }).then(function (response) {
                var objectUrl = URL.createObjectURL(response.data);
                var link = document.createElement('a');
                link.download = fileName,
                    link.href = objectUrl;
                link.click();
            })
        }

        vm.getUserName = function (user_info) {
            return SessionExternalInvitee.resolveApiVisibleDisplayName(
                user_info,
                vm.sessionModel
            );
        };

        /** Participants sidebar: thicken underscores so Technical_Support is readable at 14px. */
        vm.getParticipantNameHtml = function (user_info) {
            var name = vm.getUserName(user_info) || '';
            var escaped = name
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/_/g, '<span class="name-underscore">_</span>');
            return $sce.trustAsHtml(escaped);
        };

        vm.getParticipantsList = function () {
            var participants = vm.participantsList.map(function (participant) {
                return vm.getUserName(participant);
            });
            var guests = vm.guestList.map(function (guest) {
                return vm.getUserName(guest);
            });
            return participants.concat(guests).join(", ");
        };

        function loadTranscript(language) {
            if(!vm.isTranscriptionFeatureAvailable) {
                return;
            }
            if(language === 'hostLanguage') {
                language = vm.hostLanguage.code.split('::')[0];
            }
            vm.transcriptUrl = '/api/translate/' + vm.sessionModel.id;
            vm.loadingTranscript = true;
            $http.get(vm.transcriptUrl, {
                params: {
                    lang: language
                }
            }).then(function (response) {
                if (response && response.data.hasOwnProperty("transcripts") && response.data.transcripts.length) {
                    vm.transcriptData = response.data.transcripts.map(
                        function (transcript) {
                            var participant = transcript.participant || {};
                            var visibleName = participant.name ||
                                ((participant.first_name || '') + ' ' + (participant.last_name || '')).trim();
                            return {
                                user_name: visibleName || participant.name,
                                avatar_url: participant.avatar_url,
                                message: transcript.text,
                                duration: vm.getTranscriptMessageTime(
                                    transcript.timestamp,
                                    response.data.start_time
                                ),
                            };
                        }
                    );
                } else {
                    vm.transcriptData = [];
                }
            }).catch(function (error) {
                console.error("Error while fetching transcript", error);
                vm.transcriptData = [];
            }).finally(function () {
                vm.loadingTranscript = false;
            });
        }

        function loadAiSummary(language, isSessionTranscriptPDF, isInitLoad) {
            if(!vm.isTranscriptionFeatureAvailable) {
                vm.loadingAiSummary = false;
                vm.loadingSessionTranscriptPDF = false;
                return;
            }
            vm.loadingAiSummary = true;
            var summaryLanguage = vm.aiSummaryLanguage.id === 'hostLanguage' ? vm.hostLanguage.code.split('::')[0] : vm.aiSummaryLanguage.id
            if(isSessionTranscriptPDF) {
                summaryLanguage = language;
            }
            var params = {
                type: vm.selectedAiSummaryType.id,
                language: summaryLanguage,
                transcript_only: !vm.isAISummaryFeatureActive
            };
            Session.getAISummary(params,{
                id: vm.sessionModel.id
            }, onAiSummarySuccess, onAiSummaryError);
            function onAiSummarySuccess(response) {
                if(!isSessionTranscriptPDF && vm.isAISummaryFeatureActive) {
                    vm.aiSummary = response.summary;
                    vm.aiSummaryPDFUrl = generateMediaUrl(response.pdf.path);
                } 
                if(isSessionTranscriptPDF || isInitLoad) {
                    loadSessionTranscriptPDF(vm.selectedTranscriptLanguage.id);
                }
                vm.loadingAiSummary = false;
            }
    
            function onAiSummaryError(error) {
                vm.loadingAiSummary = false;
                if(isSessionTranscriptPDF || isInitLoad) {
                    vm.loadingSessionTranscriptPDF = false;
                }
                vm.aiSummary = "";
                console.error("Error while fetching ai summary", error);
            }
        }

        function loadSessionTranscriptPDF(language) {
            vm.transcriptPDFUrl = '';
            if(!vm.isTranscriptionFeatureAvailable) {
                vm.loadingSessionTranscriptPDF = false;
                return;
            }
            var params = {
                language: language === 'hostLanguage' ? vm.hostLanguage.code.split('::')[0] : language
            };
            Session.getSessionTranscriptPDF(params,{
                id: vm.sessionModel.id
            }, onSessionTrascriptPDFSuccess, onSessionTrascriptPDFError);

            function onSessionTrascriptPDFSuccess(response) {
                vm.transcriptPDFUrl = generateMediaUrl(response.transcript.file.path);
                vm.loadingSessionTranscriptPDF = false;
            }
            
            function onSessionTrascriptPDFError(error) {
                vm.loadingSessionTranscriptPDF = false;
                console.error("Error while fetching session transcript pdf", error);
            }
        }

        function generateMediaUrl(mediaId) {
            return "/media/documents/" + mediaId + ".pdf";
        }

        vm.selectedJob = null;

        vm.airSessionLinkedJobResource = [];
        var JOB_SESSION_LINKAGE_ALLOWED_ROUTES = [
            "storm.sessions.past",
            "storm.job-detail",
            "storm.job-detail-by-job-number",
        ];
        vm.isJobLinkageEnabled =
            Feature.isActive(
                "feature_airsession_enable_air_session_link_with_job"
            ) &&
            JOB_SESSION_LINKAGE_ALLOWED_ROUTES.includes($state.current.name);
        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        
        vm.togglePanel = function () {
            $mdSidenav('insightsPanel').toggle()
                .then(function () {

                });
        };

        vm.onTabChange = function(tabLabel) {
            if(vm.currentActiveTab === 'aiSummary' && tabLabel !== 'aiSummary') {
                vm.isAnimationLoaded = true;
            }
            vm.currentActiveTab = tabLabel;
        };
        vm.showRecordingsPanel = function () {
            $rootScope.$broadcast('showSessionRelatedPanel', 'insightsPanel', 'recordingsPanel', vm.sessionModel);
        };

        /**
         * Creates the linked resources for the session job link.
         * @param {Object} job - The job to create the linked resources for.
         * @returns {Object} The linked resources for the session job link.
         */
        vm.createLinkedResourcesForSessionJobLink = function (job) {
            return {
                linkType: "Target",
                resource: {
                    name: "jobRef",
                    type: "Job",
                    id: job.guid,
                },
                properties: {
                    jobNumber: job.jobNumber,
                    jobName: job.airformRef.name,
                },
            };
        };

        /**
         * Updates the session linked jobs resource.
         */
        vm.updateSessionLinkedJobs = function () {
            vm.airSessionLinkedJobResource = vm.sessionModel.linkedResources.filter(
                function (resource) {
                    return resource.linkType === "Target" &&
                    resource.resource.type === "Job"
                }
            );
            vm.selectedJob = null;
        };

        $rootScope.$on("refreshSessionLinkedJobsResource", function() {
            vm.updateSessionLinkedJobs();
        });

        vm.getSessionTitle = function (linkedResource) {
            if (linkedResource.hasOwnProperty("properties")) {
                return (
                    linkedResource.properties.jobNumber +
                    " - " +
                    linkedResource.properties.jobName
                );
            }
            return "";
        };

        vm.isJobDetailPage = function() {
            return ["storm.job-detail", "storm.job-detail-by-job-number"].includes($state.current.name);
        };

        vm.openJob = function (airSessionResource) {
            if (
                vm.isJobDetailPage()
            ) {
                vm.togglePanel();
            } else {
                $state.go("storm.job-detail", {
                    id: airSessionResource.resource.id,
                });
            }
        };

        /**
         * Opens the job picker dialog to select a job to link with the session.
         */
        vm.handleAddLinkedJobButtonClick = function () {
            var locals = {
                sessionNo: vm.sessionModel.session_no,
                sessionId: vm.sessionModel.id,
            };

            $mdDialog
                .show({
                    templateUrl: "modules/job/job-picker.tmpl.html",
                    controller: "JobPickerController",
                    controllerAs: "vm",
                    locals: locals,
                })
                .then(addLinkedJobDialogSuccess)
                .catch(null);
        };

        /**
         * Handles the success of the job picker dialog.
         * @param {Object} job - The selected job.
         */
        function addLinkedJobDialogSuccess(job) {
            if (job && typeof job === "object" && job.hasOwnProperty("guid")) {
                vm.selectedJob = job;
                var data = {
                    air_session_id: vm.sessionModel.id,
                    job_id: job.guid,
                };
                Session.linkJob(
                    {},
                    data,
                    handleAddLinkedApiJobSuccess,
                    addLinkedJobApiError
                );
            }
        }

        /**
         * Handles the success of the job linking API call.
         */
        function handleAddLinkedApiJobSuccess() {
            vm.sessionModel.linkedResources = [
                vm.createLinkedResourcesForSessionJobLink(vm.selectedJob),
            ];
            handleUpdateResources("add", vm.selectedJob);
            vm.selectedJob = null;
        }

        /**
         * Handles the error of the job linking API call.
         * @param {Object} error - The error object.
         */
        function addLinkedJobApiError(error) {
            console.error("error", error);
            vm.selectedJob = null;
            ToastService.displayToast(
                error.status >= 400 &&
                    error.status < 500 &&
                    !!error.data.description
                    ? error.data.description
                    : $filter("translate")(
                          "atheer.session.insights.linkingAirSessionFailed"
                      ),
                3000
            );
        }

        /**
         * Handles the update of the session linked jobs resource.
         * @param {string} action - The action to perform.
         * @param {Object} job - The job to update.
         */
        function handleUpdateResources(action, job) {
            var payload = {
                action: action,
                job: job,
                session: vm.sessionModel,
            };
            $rootScope.$emit("updateSessionLinkedJobsResource", payload);
            vm.updateSessionLinkedJobs();
        }

        /**
         * Opens the delete linked job dialog to delete a job from the session.
         * @param {Object} jobDetails - The job details.
         */
        vm.deleteLinkedJob = function (jobDetails) {
            vm.selectedJob = {
                id: jobDetails.resource.id,
                guid: jobDetails.resource.id,
                jobNumber: jobDetails.properties.jobNumber,
                jobName: jobDetails.properties.jobName,
            };
            $mdDialog
                .show({
                    templateUrl:
                        "modules/session/delete-linked-job-dialog.tmpl.html",
                    controller: "DeleteLinkedJobDialogController",
                    controllerAs: "vm",
                    locals: {},
                })
                .then(vm.deleteLinkedJobDialogSuccess)
                .catch(null);
        };

        /**
         * Handles the success of the delete linked job dialog.
         */
        vm.deleteLinkedJobDialogSuccess = function () {
            var payload = {
                air_session_id: vm.sessionModel.id,
                job_id: vm.selectedJob.id,
            };
            var headers = {
                "Content-Type": "application/json",
            };
            $http
                .delete("api/sessions/unlink/job", {
                    data: payload,
                    headers: headers,
                })
                .then(function () {
                    handleDeleteLinkedApiJobSuccess();
                })
                .catch(function (error) {
                    ToastService.displayToast(
                        error.status >= 400 &&
                        error.status < 500 &&
                        !!error.data.description
                        ? error.data.description
                        : $filter("translate")(
                            "atheer.session.insights.unlinkingAirSessionFailed"
                        ),
                        3000
                    );
                });
        };

        /**
         * Handles the success of the delete linked job API call.
         */
        function handleDeleteLinkedApiJobSuccess() {
            if (!vm.selectedJob) {
                return;
            }
            vm.sessionModel.linkedResources =
                vm.sessionModel.linkedResources.filter(function (
                    linkedResource
                ) {
                    return linkedResource.resource.id !== vm.selectedJob.id;
                });
            var payload = {
                action: "delete",
                session: vm.sessionModel,
                job: vm.selectedJob,
            };
            $rootScope.$emit("updateSessionLinkedJobsResource", payload);
            vm.selectedJob = null;
            vm.updateSessionLinkedJobs();
        }

        vm.downloadReport = function () {
            var url = '/api/sessions/pdf/' + vm.sessionModel.id;

            $http.get(url, { responseType: 'blob' }).then(function (response) {
                var objectUrl = URL.createObjectURL(response.data);
                var link = document.createElement('a');
                link.download = vm.sessionModel.session_no,
                    link.href = objectUrl;
                link.click();
            })

        }

        function transition() {
            vm.loadingActivities = true;
            Experience.getSessionActivities({
                page: vm.page - 1,
                size: vm.pageSize,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, onTSuccess, onTError);

            function onTSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.sessionActivities = data;
                getSessionActivities();
                getLineHeight();
                vm.loadingActivities = false;
            }

            function onTError(error) {
                vm.loadingActivities = false;
                AlertService.error(getInsightsErrorMessage(error));
            }
        };

        function sort() {
            return 'id,asc';
        };

        function getQueryString() {
            var queryString = "object_id==" + vm.sessionModel.id;
            return queryString;
        };

        vm.showLanguageIcon = function (language) {
            return language.id !== 'hostLanguage';
        };

        vm.getLanguagesList = function () {
            return Object.values(vm.supportedLanguages);
        };

        function setHostLanguage(defaultLanguage) {
            var hostLanguageDetail = vm.supportedLanguages.hasOwnProperty(
                defaultLanguage.replace("_", "-")
            )
                ? vm.supportedLanguages[defaultLanguage.replace("_", "-")]
                : vm.supportedLanguages["en-US"];

            vm.hostLanguage = {
                id: 'hostLanguage',
                code: hostLanguageDetail.id + '::' + hostLanguageDetail.code,
                name: 'Host Language (' + hostLanguageDetail.name + ')',
            };
            var hostLangObject = {}
            hostLangObject[vm.hostLanguage.id] = vm.hostLanguage;
            vm.supportedLanguages = Object.assign(hostLangObject, vm.supportedLanguages);
            vm.aiSummaryLanguage = vm.hostLanguage;
            vm.selectedTranscriptLanguage = vm.hostLanguage;

            if(vm.isAISummaryFeatureActive || vm.isTranscriptionFeatureAvailable) {
                loadAiSummary(null, false, true);
            }
            if (vm.isTranscriptionFeatureAvailable) {
                vm.loadingSessionTranscriptPDF = true;
                loadTranscript(vm.selectedTranscriptLanguage.id);
            }
        }

        function loadSessionLinkedAssets() {
            vm.sessionLinkedAssets = [];
            if (!vm.isALMFeatureEnabled || !vm.sessionModel) {
                return;
            }
            var sessionId = IBM.resolveAirSessionId(vm.sessionModel);
            if (!sessionId) {
                return;
            }
            IBM.getAssets({ airsession: sessionId })
                .then(function (result) {
                    vm.sessionLinkedAssets = IBM.parseAssetsResponse(result);
                })
                .catch(function (error) {
                    vm.sessionLinkedAssets = [];
                    console.error('Error loading linked session assets', error);
                });
        }

        function loadData() {
            if (!vm.sessionModel) {
                return;
            }
            continueLoadData();
        }

        function continueLoadData() {
            vm.updateSessionLinkedJobs();
            vm.loadingData = true;
            vm.isLoadingFeedback = true;
            
            if(vm.sessionModel && vm.sessionModel.hasOwnProperty("owner_info") && vm.sessionModel.owner_info.hasOwnProperty("language_id")) {
                setHostLanguage(
                    vm.sessionModel.owner_info.language_id
                );
            } else {
                setHostLanguage("en-US");
            }

            Experience.getSessionActivities({
                page: 0,
                size: vm.pageSize,
                sort: sort(),
                query: getQueryString(),
                user_info: true
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.sessionActivities = data;
                vm.page = 1;
                vm.loadingData = false;
                getSessionActivities();
                getLineHeight();
            }

            function onError(error) {
                vm.loadingData = false;
                vm.loadingActivities = false;
                AlertService.error(getInsightsErrorMessage(error));
            }

            getParticipantsList();
            getRatingsAndComments();
            loadSessionLinkedAssets();
        };

        function getRatingsAndComments() {
            Experience.getSessionRatingAndComments({
                page: 0,
                size: vm.feedbackPageSize,
                sort: sort(),
                query: getRatingAndCommentsQueryString(),
                user_info: true
            }, onSuccess, onError);

            function onSuccess(result, headers) {
                vm.feedbackLinks = ParseLinks.parse(headers('link'));
                vm.feedbackQueryCount = headers('X-Total-Count');
                vm.ratingAndCommentsActivities = result;
                vm.feedbackPage = 1;
                vm.isLoadingFeedback = false;

                getFeedbackDetails();
            };

            function onError(error) {
                vm.isLoadingFeedback = false;
                vm.loadingFeedbackActivities = false;
                AlertService.error(getInsightsErrorMessage(error));
            };
        };

        function getRatingAndCommentsQueryString() {
            return "action_type==FEEDBACK;object_id==" + vm.sessionModel.id;
        };

        function getFeedbackDetails() {
            vm.feedbackActivities = [];
            angular.forEach(vm.ratingAndCommentsActivities, function (ratingAndCommentActivity) {
                if (ratingAndCommentActivity.activity_type == 'FEEDBACK') {
                    vm.feedbackActivities.push(ratingAndCommentActivity);
                }
            });
        };

        function getLineHeight() {
            setTimeout(function () {
                angular.forEach(vm.session_activities, function (session_activity, index) {
                    var line = document.getElementById('activity-line-' + index);
                    if (!line || !session_activity || !session_activity.activities) {
                        return;
                    }
                    line.style.height = (session_activity.activities.length == 1 ? 59 : 76 * session_activity.activities.length - 17) + 'px';
                });
            }, 500);
        };

        function getInsightsErrorMessage(error) {
            if (error && error.data && error.data.message) {
                return error.data.message;
            }
            if (error && error.statusText) {
                return error.statusText;
            }
            return 'error.http.serverError';
        }

        function getSessionActivities() {
            vm.session_activities = [];
            angular.forEach(vm.sessionActivities, function (sessionActivity) {
                var created_on_1 = moment(sessionActivity.created_on).format('LT');
                var exists = false;
                var full_name = vm.getUserName(sessionActivity.user_info);
                angular.forEach(vm.session_activities, function (session_activity) {
                    var created_on_2 = session_activity.created_on;
                    if (angular.equals(created_on_1, created_on_2)) {
                        exists = true;
                        var obj = {
                            activity: sessionActivity.activity_type,
                            activator: full_name,
                            user_info: sessionActivity.user_info
                        };
                        session_activity.activities.push(obj);
                    }
                });
                if (!exists && sessionActivity.id != "") {
                    var obj = {
                        created_on: created_on_1,
                        activities: [
                            {
                                activity: sessionActivity.activity_type,
                                activator: full_name,
                                user_info: sessionActivity.user_info
                            }
                        ]
                    };
                    vm.session_activities.push(obj);
                }
            });
        };

        vm.getProfilePicture = function (user_info) {
            if (SessionExternalInvitee.shouldUseMaskedNameForApiUser(user_info, vm.sessionModel)) {
                return 'assets/images/avatars/user-avatar.png';
            }
            return user_info && user_info.picture_id
                ? '/media/pictures/' + user_info.picture_id
                : 'assets/images/avatars/user-avatar.png';
        };

        vm.feedbackTransition = function () {
            vm.loadingFeedbackActivities = true;
            Experience.getSessionRatingAndComments({
                page: vm.feedbackPage - 1,
                size: vm.feedbackPageSize,
                sort: sort(),
                query: getRatingAndCommentsQueryString(),
                user_info: true
            }, onTSuccess, onTError);

            function onTSuccess(result, headers) {
                vm.feedbackLinks = ParseLinks.parse(headers('link'));
                vm.feedbackQueryCount = headers('X-Total-Count');
                vm.ratingAndCommentsActivities = result;
                getFeedbackDetails();
                vm.loadingFeedbackActivities = false;
            };

            function onTError(error) {
                vm.loadingFeedbackActivities = false;
                AlertService.error(getInsightsErrorMessage(error));
            };
        };

        function getParticipantsList() {
            vm.participantsList = [];
            vm.guestList = [];
            if (vm.sessionModel.owner_info) {
                var owner = vm.sessionModel.owner_info;
                var hostObj = vm.sessionModel.session_host;
                var ownerMask = false;
                if (hostObj && hostObj.user_id != null &&
                    String(hostObj.user_id) === String(owner.id) &&
                    typeof hostObj.use_masked_name === 'boolean') {
                    ownerMask = hostObj.use_masked_name;
                }
                var obj = {
                    user_id: owner.id,
                    id: owner.id,
                    first_name: owner.first_name,
                    last_name: owner.last_name,
                    picture_id: owner.picture_id,
                    custom_attributes: owner.custom_attributes,
                    use_masked_name: ownerMask,
                    joined: false
                };

                vm.participantsList.push(obj);
            }

            if (vm.sessionModel.session_users_info) {
                angular.forEach(vm.sessionModel.session_users, function (sessionUser) {
                    angular.forEach(vm.sessionModel.session_users_info, function (sessionUserInfo) {
                        if (!sessionUser || !sessionUserInfo) {
                            return;
                        }
                        if (sessionUser.user_id != sessionUserInfo.id) {
                            return;
                        }
                        var participantObj = {
                            user_id: sessionUserInfo.id,
                            id: sessionUserInfo.id,
                            first_name: sessionUserInfo.first_name,
                            last_name: sessionUserInfo.last_name,
                            picture_id: sessionUserInfo.picture_id,
                            custom_attributes: sessionUserInfo.custom_attributes,
                            use_masked_name: sessionUser.use_masked_name,
                            joined: false
                        };
                        if (!sessionUser.is_guest) {
                            vm.participantsList.push(participantObj);
                        } else {
                            vm.guestList.push(participantObj);
                        }
                    });
                });
            }

            angular.forEach(vm.sessionModel.session_joined_users_info, function (sessionJoinedUserInfo) {
                angular.forEach(vm.participantsList, function (participant) {
                    if (participant.user_id == sessionJoinedUserInfo.id) {
                        participant.joined = true;
                    }
                });
                angular.forEach(vm.guestList, function (participant) {
                    if (participant.user_id == sessionJoinedUserInfo.id) {
                        participant.joined = true;
                    }
                });
            });
        };

        function getParticipantDetails(sessionUser) {

        }

        $scope.$watch('vm.sessionModel', function (newValue) {
            if (angular.isDefined(vm.sessionModel) && vm.sessionModel != null) {
                loadData();
            }
        });
    };
})();
